import { render } from "./LoadingButtonDots.vue?vue&type=template&id=87752508"
import script from "./LoadingButtonDots.vue?vue&type=script&lang=js"
export * from "./LoadingButtonDots.vue?vue&type=script&lang=js"

import "./LoadingButtonDots.vue?vue&type=style&index=0&id=87752508&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__